import React, { createContext, useContext, useState, ReactNode, useRef } from 'react';

interface HGSelectorContextType {
  hGSelectorMode: boolean;
  selectedHGroups: string[];
  setSelectedHGroups: (selectedGroups: string[]) => void;
  selectLimit?: number;
  setSelectLimit?: (limit: number | undefined) => void;
}

const contextDefaultValue: HGSelectorContextType = {
  hGSelectorMode: false,
  selectedHGroups: [],
  setSelectedHGroups: () => { },
  selectLimit: undefined,
  setSelectLimit: () => { },
};

const HGSelectorContext = createContext<HGSelectorContextType>(contextDefaultValue);

export const HGSelectorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [hGSelectorMode, _] = useState<boolean>(true);
  const [selectedHGroups, setSelectedHGroups] = useState<string[]>(contextDefaultValue.selectedHGroups);
  const [selectLimit, setSelectLimit] = useState<number | undefined>(contextDefaultValue.selectLimit);

  return (
    <HGSelectorContext.Provider
      value={{
        hGSelectorMode,
        selectedHGroups,
        setSelectedHGroups,
        selectLimit,
        setSelectLimit,
      }}
    >
      {children}
    </HGSelectorContext.Provider>
  );
};

export const useHGSelectorContext = (): HGSelectorContextType => {
  const context = useContext(HGSelectorContext);
  const {
    hGSelectorMode,
    selectedHGroups,
    setSelectedHGroups,
    selectLimit,
    setSelectLimit,
  } = context;
  // do not throw error as this way we can check if hierarchy is
  // opened in a modal and apply the logic accordingly
  // -----------------------------------------------------------
  // if (context === undefined) {
  //   throw new Error('useHGSelectorContext must be used within a HGSelectorProvider');
  // }
  return {
    hGSelectorMode,
    selectedHGroups,
    setSelectedHGroups,
    selectLimit,
    setSelectLimit,
  }
};